
export class BulkReport{
    constructor({
        id,
        classList,
        createdBy,
        title,
        description,
        itemCount,
        processedStudents,
        totalStudents,
        createdAt,
        updatedAt,
        status,
        zipUrl,
        zipPath,
        error

    }){
        this.id = id;
        this.classList = classList;
        this.createdBy = createdBy;
        this.title = title;
        this.description = description;
        this.itemCount = itemCount;
        this.processedStudents = processedStudents; 
        this.totalStudents = totalStudents;
        this.createdAt = this._convertTimestamp(createdAt);
        this.updatedAt = this._convertTimestamp(updatedAt);
        this.status = status;
        this.zipUrl = zipUrl;
        this.zipPath = zipPath;
        this.error = error;
    }

    /**
     * Converts Firestore timestamp to JavaScript Date
     * @param {Object} timestamp - Firestore timestamp object with _seconds and _nanoseconds
     * @returns {Date|null} - JavaScript Date object or null
     */
    _convertTimestamp(timestamp) {
        if (!timestamp || typeof timestamp !== 'object') return null;
        
        // Handle Firestore Timestamp object with _seconds and _nanoseconds
        if (timestamp._seconds !== undefined && timestamp._nanoseconds !== undefined) {
            return new Date(timestamp._seconds * 1000);
        }
        
        return null;
    }

    static fromMap(map){
        return new BulkReport(map)
    }
}


export const BulkReportStatus = {
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FAILED: 'failed'
}

export const BulkReportType = {
    STUDENT_PERFORMANCE: 'student_performance',

}